module.exports = __webpack_public_path__ + "img/free_multiplier_4.b0a2f12b.png";